import PropTypes from 'prop-types';
import styles from './FJWarningModal.module.less';
import classNames from 'classnames';
import FJModalClose from '../FJModalClose/FJModalClose';
import FJConstant from '../../../constants/FJConstant';
import CreditIcon from '../../../assets/svg/credit.svg?react';
import useIsMobile from '../../../hooks/useIsMobile';
import FJLocalStore from '../../../store/FJLocalStore';
import FJCheckBox from '../../../common/components/FJCheckBox/FJCheckBox';
import { useState, useEffect } from 'react';
import FJButton, { FJButtonType } from '../../../common/components/FJButton/FJButton';

const FJWarningModal = props => {
    const {
        title,
        content,
        footerDates,
        onClose,
        isShowApplyBtn = false,
        propsIsApply = false,
        isShow = false,
        checkBoxText = FJLocalStore._('apply-to-all'),
    } = props;

    const [isApply, setIsApply] = useState(propsIsApply);
    const isMobile = useIsMobile();

    useEffect(() => {
        setIsApply(propsIsApply);
    }, [isShow, propsIsApply]);

    const _getFootBtn = () => {
        return (
            footerDates &&
            footerDates.map((item, idx) => {
                if (item.btnType === FJButtonType.GRADIENT) {
                    return (
                        <FJButton
                            key={idx}
                            text={item.btnText}
                            className={styles.btn_box}
                            type={FJButtonType.GRADIENT}
                            textClassName={styles.btn_text}
                            onClick={() => {
                                item.btnCallback && item.btnCallback(isApply);
                                onClose && onClose();
                            }}
                        />
                    );
                }

                return (
                    <div
                        // 仅有索引为key(编辑页移植)
                        key={idx}
                        className={classNames(styles.btn_box, styles[item.btnType])}
                        onClick={() => {
                            item.btnCallback && item.btnCallback(isApply);
                            onClose && onClose();
                        }}
                    >
                        <span className={styles.btn_text}>{item.btnText}</span>
                        {item.btnType === FJConstant.GET_CREDITS && <CreditIcon className={styles.icon} />}
                    </div>
                );
            })
        );
    };
    return (
        <div className={classNames(styles.box, isMobile && styles.mobile)}>
            {!isMobile && <FJModalClose onClick={onClose} />}
            <div className={styles.title}>{title}</div>
            <div className={styles.content}>{content}</div>
            <div className={styles.footer}>
                {isShowApplyBtn && (
                    <div className={styles.apply_btn}>
                        <FJCheckBox dataChange={setIsApply} selected={isApply} />
                        {checkBoxText}
                    </div>
                )}
                {_getFootBtn()}
            </div>
        </div>
    );
};
FJWarningModal.propTypes = {
    title: PropTypes.string,
    content: PropTypes.string,
    footerDates: PropTypes.array,
    onClose: PropTypes.func,
    isShowApplyBtn: PropTypes.bool,
    propsIsApply: PropTypes.bool,
    isShow: PropTypes.bool,
    checkBoxText: PropTypes.string,
};
export default FJWarningModal;
